import HowFeelProductsSection from './HowFeelProductsSection';

export default HowFeelProductsSection;
